// ======================================================================
// File Name       : MessageSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import MessageView from '../components/MessageView';
import { MESSAGE_TYPE } from '../constants/index';
import { MSG_SEARCH_RESULT_NOT_MATCH } from '../constants/MessageTemplate';

class MessageSearch extends React.Component {
  render() {
    const resultList = this.props.resultList || [];
    const recordNum = this.props.recordNum || 0;
    const isAllowShowMessage = this.props.isAllowShowSearchMessage;
    let isShowMessage = false;
    if (isAllowShowMessage && (!resultList || !resultList.length || !recordNum)) {
      isShowMessage = true;
    }
    const message = {
      messageVisible: isShowMessage,
      messageType: MESSAGE_TYPE.success,
      messageHeader: '',
      messageContent: [MSG_SEARCH_RESULT_NOT_MATCH],
    };
    return (
      <MessageView
        message={message}
        onDismiss={this.props.dismissMessage}
      />
    );
  }
}
export default MessageSearch;
